module.exports = __webpack_public_path__ + "static/media/taart.f04df91d.jpg";